import React from 'react';
import editModal from './editModal';
import BackgroundSettings from './backgroundSettings';
import OverlaySetting from './overlaySetting';

export const OPTION_PATTERN = 'pattern';

export default (editorProps = () => {}, tabs = []) => editModal(
  (props) => {
    const inherited = editorProps(props) || {};
    const { sectionStyle } = props;

    return {
      title: inherited.title || 'Background Editor',
      ...inherited,
      initialValues: { sectionStyle } || {},
    };
  },
  props =>

    tabs.concat([{
      name: 'Background ',
      children: (
        <BackgroundSettings {...props} />
      ),
    },
    {
      name: 'Overlay',
      children: (
        <OverlaySetting {...props} />
      ),
    },
    ])
  ,
);
